import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TextTruncate from 'react-text-truncate';
import AspectRatio from 'react-aspect-ratio';
import { parseYouTubeUrl } from 'appSrc/utils/video';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/NewPlayIcon';
import { YouTubeCoverImage, UserAvatar } from 'appSrc/components/UI';
import style from './styles/style.module.css';
import { connect } from 'react-redux';
import { showModal } from 'appSrc/redux/actions';

class ReviewRowCard extends PureComponent {

    playMovie = (youTubeId, metaData) => {
        this.props.playMovie(youTubeId, metaData);
    }

    render() {
        const { review } = this.props;
        const author = review.author;
        var profession;
        if( author ) {
            profession = author.profession;
            if( profession && profession.title ) {
                profession = profession.title;
            }
        }

        var video = review.video_url;
        var videoId;
        if( video ) {
            videoId = parseYouTubeUrl( video );
        }

        const movieMetaData = {
            attached_to: 'review_video',
            attached_id: review.id,
            video_author_id: review.userid,
        };

        return (
            <div className={ `${ style.reviewRowCard } ${ this.props.className }`.trim() }>
                <Link to={ `/app/products/${ review.desireid }` } className={ style.backgroundLink }></Link>
                <AspectRatio ratio='16/9' className={ style.coverWrapper }>
                    <div className={ style.video }>
                        <YouTubeCoverImage videoId={ videoId } className={ style.videoImage } />
                        <TheaterPlayIcon className={ style.playIcon } youtubeId={ videoId }
                        metaData={ movieMetaData } />
                    </div>
                </AspectRatio>
                <div className={ style.text }>
                    <TextTruncate
                    line={ 2 }
                    text={ review.title }
                    title={ review.title }
                    containerClassName={ style.title }/>
                    { author &&
                        <div className={ style.authorInfo }>
                            <UserAvatar src={ author.avatar } size={ 35 } />
                            <div className={ style.infoText }>
                                { profession &&
                                    <div className={ style.profession }>{ profession }</div>
                                }
                                <div className={ style.displayName }>{ author.displayName }</div>
                            </div>
                        </div>
                    }
                </div>

            </div>
        );
    }
}
ReviewRowCard.propTypes = {
    review: PropTypes.object.isRequired,
};
ReviewRowCard.defaultProps = {
    className: '',
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        playMovie: ( youtubeId, metaData ) => {
            dispatch( showModal( 'movieTheater', { youtubeId: youtubeId, metaData: metaData } ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( ReviewRowCard );
